export default class Home {
    constructor() {
        window.addEventListener('resize', (e) => {
            this.video();
        });

        this.video();
    }

    video() {
        if (document.querySelector('#homepage #hero video')) {
            const video = document.querySelector('#homepage #hero video');
            const source = document.createElement('source');
            video.innerHTML = "";
            source.setAttribute('type', 'video/mp4');

            if (window.innerWidth < 992) {
                source.setAttribute('src', '/mobile.mp4');
            } else {
                source.setAttribute('src', '/desktop.mp4');
            }

            video.appendChild(source);
            video.load();
        }
    }
}
